import React, { useEffect, useMemo } from 'react';
import { Button, LoadingData, NoData } from '@hwm/ui-lib';
import { Trans } from '@lingui/macro';
import { noDataInformationOptionsFn, NoDataInformationType } from '@shared/components';
import { SelectedSitesListModel } from '@shared/models';
import { isEmpty } from 'lodash';
import { useSelectedSitesDataSource } from '../SiteList/sitesDataSource';

export const SelectedSitesLists: React.FC = () => {
  const { selectedLists, selectedSitesList, loading, handleGetSelectedLists, handleLoadSelectedList } =
    useSelectedSitesDataSource();

  useEffect(() => {
    handleGetSelectedLists();
  }, [handleGetSelectedLists]);

  const emptyData = useMemo(() => !selectedLists || (selectedLists && isEmpty(selectedLists)), [selectedLists]);

  return (
    <div className="overflow-y-auto overflow-x-hidden h-full">
      {loading ? (
        <LoadingData />
      ) : emptyData ? (
        <NoData
          additionalText={noDataInformationOptionsFn()[NoDataInformationType.EmptySelectedSitesList]}
          showCompanyLogo
        />
      ) : (
        <div className="flex flex-col mx-8 sm:mx-12">
          <Button
            style={{ marginBottom: 8, height: 36 }}
            variant={selectedSitesList === null ? 'contained' : 'outlined'}
            onClick={() => handleLoadSelectedList(null)}
            disabled={loading}
          >
            <Trans>Empty</Trans>
          </Button>
          {selectedLists?.map((list: SelectedSitesListModel) => {
            return (
              <Button
                key={list.id}
                style={{ marginBottom: 8, height: 36 }}
                variant={list.id === selectedSitesList?.id ? 'contained' : 'outlined'}
                onClick={() => handleLoadSelectedList(list)}
                disabled={loading}
              >
                {list.name}
              </Button>
            );
          })}
        </div>
      )}
    </div>
  );
};
